import { render, staticRenderFns } from "./PlaylistItemAudioModal.vue?vue&type=template&id=4c767180&scoped=true"
import script from "./PlaylistItemAudioModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaylistItemAudioModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlaylistItemAudioModal.vue?vue&type=style&index=0&id=4c767180&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c767180",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c767180')) {
      api.createRecord('4c767180', component.options)
    } else {
      api.reload('4c767180', component.options)
    }
    module.hot.accept("./PlaylistItemAudioModal.vue?vue&type=template&id=4c767180&scoped=true", function () {
      api.rerender('4c767180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PlaylistItemAudioModal.vue"
export default component.exports